interface Suggestion {
  name: string,
  values: string[]
};

export default class SpellSuggestion {

  static render(suggestions: Suggestion[], searchPageUrl: string) {
    if (suggestions) {
      const element = document.getElementById('js-spell-suggestion')
      const template = `${suggestions.reduce((acc, suggestionItem) => {
        return acc = acc + `
          <li>
            <a class="search-suggestion-link" href="${searchPageUrl + suggestionItem.values[0]}">${window.decodeURIComponent(suggestionItem.values[0]).replace(/\+/g, '')}</a>
          </li>
        `
      }, ``)
        }`
      element.innerHTML = template;
    }
  }
}
